import { Command, CommandHandler, HttpService, TaggedUrl, Tags } from '@skylab-shared/core';

export interface AccountancySendEmailMultiCommandParams {
    ids: number[];
    recipients: string[];
    compress: boolean;
    password?: string;
    mailTemplateSubject: string;
    mailTemplateContent: string;
    senderName: string;
}

export type AccountancySendEmailMultiCommandResult = null;

export class AccountancySendEmailMultiCommand extends Command<AccountancySendEmailMultiCommandParams, void> { }

export class AccountancySendEmailMultiCommandHandlerBase implements CommandHandler<AccountancySendEmailMultiCommand, AccountancySendEmailMultiCommandParams, void> {
    private static Url = TaggedUrl.join('/accounting/batch/email', [Tags.Api]);

    public constructor(private readonly http: HttpService) { }

    public async handleAsync({ params }: AccountancySendEmailMultiCommand): Promise<void> {
        await this.http.post<AccountancySendEmailMultiCommandResult>(AccountancySendEmailMultiCommandHandlerBase.Url, { ...params });
    }
}
